export default __webpack_public_path__ + "static/64bee702-d80e-4be0-9a90-61d7635b6d7c-e4e50f4bbbeaa6404be6daf738214787.woff";